import Accordion from "@/components/Accordion";
import { tv } from "tailwind-variants";
import poster from "@/assets/images/collect/usage-image.png";
import videoMp4 from "@/assets/videos/collect/usage-dashboard.mp4";
import videoWebm from "@/assets/videos/collect/usage-dashboard.webm";
import { useTranslation } from "react-i18next";

const styles = tv({
  slots: {
    row: "grid grid-cols-1 grid-rows-3 gap-10 sm:grid-cols-3 sm:grid-rows-1 sm:gap-30",
    statRow: "flex flex-row items-center gap-15",
    statText:
      "min-w-70 text-[22px] font-bold leading-[35px] sm:min-w-[unset] sm:text-[52px] sm:leading-[64px]",
    video: "hidden h-auto max-h-[380px] w-full p-20 sm:block",
  },
  variants: {
    color: {
      blue: {
        statText: "text-primary",
      },
      green: {
        statText: "text-green",
      },
    },
  },
});

interface IProps {
  data: IGetUsageDashboardRS;
}

const StatsAndVideo = ({ data }: IProps) => {
  const { t } = useTranslation();
  const { row, statRow, statText, video } = styles();

  const {
    numFirstTimeVerifiedContacts,
    numVerifiedContactUpdates,
    numUpdates,
  } = data;

  const renderStats = () => (
    <div className={row()}>
      <div className={statRow()}>
        <h2
          className={statText({ color: "blue" })}
          data-testid="usage-dashboard-stat">
          {numFirstTimeVerifiedContacts.toLocaleString()}
        </h2>
        {t("email.usage.statsAndVideo.verifiedContacts")}
      </div>
      <div className={statRow()}>
        <h2
          className={statText({ color: "blue" })}
          data-testid="usage-dashboard-stat">
          {numVerifiedContactUpdates.toLocaleString()}
        </h2>
        {t("email.usage.statsAndVideo.updates")}
      </div>
      <div className={statRow()}>
        <h2
          className={statText({ color: "green" })}
          data-testid="usage-dashboard-stat">
          {numUpdates.toLocaleString()}
        </h2>
        {t("email.usage.statsAndVideo.updatesMade")}
      </div>
    </div>
  );

  const renderVideo = () => (
    <video
      playsInline
      autoPlay
      loop
      muted
      poster={poster}
      className={video()}
      data-testid="usage-dashboard-video">
      <source src={videoMp4} type="video/mp4"></source>
      <source src={videoWebm} type="video/webm; codecs=vp9,vorbis"></source>
    </video>
  );

  return (
    <Accordion
      topContent={renderStats()}
      hasShadow={false}
      defaultIsExpanded
      hideToggle
      disableChildPadding>
      {renderVideo()}
    </Accordion>
  );
};

export default StatsAndVideo;
